<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p9"><span><a href="#/Contents#rp9">VEAL STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Veal bones and stew meat can be hard to find, so make this delicately flavored stock when you can find the ingredients and freeze it.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>1½ pounds veal stew meat</span></p>
<p class="hang"><span>½ cup each: chopped onion, carrot, celery</span></p>
<p class="hang"><span>2 quarts water</span></p>
<p class="hang"><span>1 veal knuckle or veal bones (about 1¾ pounds)</span></p>
<p class="hang"><span>2 bay leaves</span></p>
<p class="hang"><span>6 black peppercorns</span></p>
<p class="hang"><span>3 whole cloves</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Cook veal stew meat in lightly greased large Dutch oven until browned, 8 to 10 minutes; remove and reserve. Add vegetables and sauté until browned, about 5 minutes. Return veal to Dutch oven; add remaining ingredients, except salt and pepper, and heat to boiling. Reduce heat and simmer, covered, 4 hours, skimming any foam from surface. Strain through double layer of cheesecloth, discarding meat, bones, vegetables, and seasonings; season to taste with salt and pepper. Refrigerate until chilled; remove congealed fat from stock.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 17</span></p>
<p class="per1"><span>% calories from fat: 36</span></p>
<p class="per1"><span>Protein (g): 2.4</span></p>
<p class="per1"><span>Carbohydrate (g): 0.2</span></p>
<p class="per1"><span>Fat (g): 0.6</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 8.9</span></p>
<p class="per1"><span>Sodium (mg): 6</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter019.vue?bc2cda90